module.exports = __webpack_public_path__ + "img/unlocking_leadership.ba045941.png";